import Planos from "@/Pages/Planos/index.vue";
import PlanosInfantil from "@/Pages/PlanosInfantil/index.vue";
import PlanosVisualizar from "@/Pages/Planos/visualizar.vue";
import PlanosInfantilVisualizar from "@/Pages/PlanosInfantil/visualizar.vue";
import GerenciarPlanos from "@/Pages/GestaoDePlanos/index.vue";
import NewEditDocumentosPlanosPage from "@/Pages/GestaoDePlanos/NewEditDocumentosPlanosPage.vue";
import { can } from "@/plugins/can";
import PlanejamentoDeAulas from "../Pages/GestaoDeAulas/PlanejamentoDeAulas.vue";

export default [
  {
    path: "/gestoes-de-aulas/planos",
    name: "gestoesDeAulas.planos",
    component: Planos,
  },
  {
    path: "/gestoes-de-aulas/planos/:id/visualizar",
    name: "gestoesDeAulas.planosVisualizar",
    component: PlanosVisualizar,
  },
  // Infantil
  {
    path: "/gestoes-de-aulas/planos/infantil",
    name: "gestoesDeAulas.planosInfantil",
    component: PlanosInfantil,
  },
  {
    path: "/gestoes-de-aulas/planos/infantil/:id/visualizar",
    name: "gestoesDeAulas.planosInfantilVisualizar",
    component: PlanosInfantilVisualizar,
  },
  {
    path: "/gestoes-de-aulas/planos/gerenciar",
    name: "gerenciarPlanos",
    component: GerenciarPlanos,
  },
  {
    path: "/gerenciar-planos/create",
    name: "documentosPlanos.create",
    component: NewEditDocumentosPlanosPage,
    props: { editing: false },
  },
  {
    path: "/gerenciar-planos/edit/:documentoId",
    name: "documentosPlanos.edit",
    component: NewEditDocumentosPlanosPage,
    props: (route) => ({ editing: true, documentoId: parseInt(route.params.documentoId, 10) }),
  },
  {
    path: "/gestoes-de-aulas/planejamento-de-aulas",
    name: "gestoesDeAulas.planejametoDeAulas",
    component: PlanejamentoDeAulas,

    beforeEnter: (to, from, next) => {
      if (!can(["planejamentoDeAulas.*"])) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
];
